import { useState } from "react";
import { Pressable, View, StyleSheet } from "react-native";

import { ReactComponent as MenuOpenImg } from '../../../img/ico-side-bar-menu-side-bar-open.svg';

import SideBarCollapsedMenuItem from "./sideBarCollapsedMenuItem";
import { SideBarItemData, SideBarMenus } from "./sideBarData";

interface SideBarCollapsedMenuProps {
    toggleSizeCb: Function
}

export default function SideBarCollapsedMenu(props:SideBarCollapsedMenuProps) {
    const [toggleButtonContainerStyle, setToggleButtonContainerStyle] = useState(style.menuBar);
    const [hoverItem, setHoverItem] = useState(0);
    const [activeItem, setActiveItem] = useState(0);

    function menuItemActive(id:number) {
        setActiveItem(id);
    }

    function menuItemHover(id:number) {
        setHoverItem(id);
    }

   
    return (
        <View>
            <Pressable
                style={toggleButtonContainerStyle}
                onPress={()=>props.toggleSizeCb(true)}
                onHoverOut={()=>{setToggleButtonContainerStyle({...style.menuBar, backgroundColor:"#212943"});}}
                onHoverIn={()=>{setToggleButtonContainerStyle({...style.menuBar, backgroundColor:"#323ba6"});}}
            >
                <MenuOpenImg />
            </Pressable>
            {
                SideBarMenus.map((menu:SideBarItemData, index) => {
                    return (
                        <SideBarCollapsedMenuItem key={index} item={menu} menuItemHoverCb={menuItemHover} menuItemActiveCb={menuItemActive} hoverItemIdForOpenSubItem={hoverItem} activeItemId={activeItem}/>
                    )
                })
            }
        </View>
    );
}

const style = StyleSheet.create({
    menuBar:{
        height: 50,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#212943",
        zIndex:8,
    }
})